import axios from "axios"
import store from "@/store";

// const MOCK_ARTICLES = [
//   { id: 101, name: "Tarta de Queso RA6_12" },
//   { id: 102, name: "Tarta de Manzana" },
//   { id: 103, name: "Bizcocho de Chocolate" },
// ];

// const MOCK_INGREDIENTS_BY_ARTICLE = {
//   101: [
//     { id: 1, name: "Queso crema", unit: "g", recipeQty: 500, usedQty: null, batch: "" },
//     { id: 2, name: "Azúcar", unit: "g", recipeQty: 120, usedQty: null, batch: "" },
//     { id: 3, name: "Huevos", unit: "ud", recipeQty: 3, usedQty: null, batch: "" , step: 1 },
//     { id: 4, name: "Nata", unit: "ml", recipeQty: 200, usedQty: null, batch: "" },
//     { id: 5, name: "Base galleta", unit: "g", recipeQty: 180, usedQty: null, batch: "" },
//   ],
//   102: [
//     { id: 6, name: "Manzana", unit: "g", recipeQty: 300, usedQty: null, batch: "" },
//     { id: 7, name: "Harina", unit: "g", recipeQty: 150, usedQty: null, batch: "" },
//     { id: 8, name: "Canela", unit: "g", recipeQty: 5, usedQty: null, batch: "" },
//   ],
//   103: [
//     { id: 9, name: "Cacao", unit: "g", recipeQty: 50, usedQty: null, batch: "" },
//     { id: 10, name: "Harina", unit: "g", recipeQty: 200, usedQty: null, batch: "" },
//     { id: 11, name: "Leche", unit: "ml", recipeQty: 250, usedQty: null, batch: "" },
//   ]
// };

function getBaseUrl() {
  const url = store.state.urlRaiz || "";
  return url.endsWith("/") ? url.slice(0, -1) : url;
}

export default {
  // async getArticles() {
  //   await delay(300);
  //   return MOCK_ARTICLES;
  // },

  async getArticles(divisionId = null) {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${getBaseUrl()}/api/ztrazabilidadobrador/articles`,
      {
        params: {
          divisionId
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );

    return res.data;
  },
  async getDivisions() {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${getBaseUrl()}/api/ztrazabilidadobrador/divisions`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );

    return res.data || [];
  },
  // async getPeople() {
  //   await delay(200);
  //   return MOCK_PEOPLE;
  // },
  // async getIngredientsByArticle(articleId) {
  //   await delay(400);
  //   return (MOCK_INGREDIENTS_BY_ARTICLE[articleId] || []).map(x => ({...x}));
  // },
  // async saveTraceability(payload) {
  //   // Aquí llamarías a tu API real con fetch/axios
  //   await delay(500);
  //   console.log("TRACEABILITY PAYLOAD", payload);
  //   return { ok: true };
  // }
  async getIngredientsByArticle(articleId) {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${getBaseUrl()}/api/ztrazabilidadobrador/ingredientsByArticle`,
      {
        params: { articleId },
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );

    return res.data;
  },
  async saveTraceability(payload, urlRaiz) {
    const token = localStorage.getItem("token");

    return axios.post(
      `${urlRaiz}/api/ztrazabilidadobrador/create`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );
  },
  async getTraceability(id, urlRaiz) {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${urlRaiz}/api/ztrazabilidadobrador/get`,
      {
        params: { id },
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );

    return res.data;
  },

  async updateTraceability(payload, urlRaiz) {
    const token = localStorage.getItem("token");

    return axios.post(
      `${urlRaiz}/api/ztrazabilidadobrador/update`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );
  },
  async getTraceabilityForEdit(id, urlRaiz) {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${urlRaiz}/api/ztrazabilidadobrador/getForEdit`,
      {
        params: { id },
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    );

    return res.data;
  },
  async getPeople() {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${getBaseUrl()}/api/ztrazabilidadobrador/people`,
      {
        headers: {
          Authorization: token
        }
      }
    );

    return res.data;
  }
};